import type { DashboardRecord } from './dash-types';
import {
	MOCK_LIGHT_CATALOG,
	MOCK_LIGHT_COHORT_LABELS,
	getMockLightIdsByCohort,
} from 'src/helpers/dev/mock_light_catalog';
import { MOCK_LIGHT_GROUP_IDS, type MockLightCohort } from 'src/helpers/dev/mock_light_ids';

/** Virtual, client-only dashboard id. Negative ids cannot collide with persisted dashboards. */
export const MOCK_LIGHTS_DASHBOARD_ID = -106;
export const MOCK_LIGHTS_DASHBOARD_ROUTE = '/-106';

export const MOCK_LIGHTS_DASHBOARD_TAB = {
	id: MOCK_LIGHTS_DASHBOARD_ID,
	key: 'mock_lights_gallery',
	text: 'Mock Lights',
	defaultText: 'Mock Lights',
	route: MOCK_LIGHTS_DASHBOARD_ROUTE,
	icon: 'fas fa-lightbulb',
	backgroundColor: 'color-2',
} as const;

const COHORT_ORDER: MockLightCohort[] = ['rgbWw', 'rgb', 'cct', 'dimmer'];

const COHORT_LIGHT_BG = [
	'--gradient-red-purple',
	'--gradient-royal-purple',
	'--gradient-orange-magenta',
	'--gradient-blue-green',
] as const;

const deviceCardsForCohort = (cohort: MockLightCohort) =>
	getMockLightIdsByCohort(cohort).map((id, position) => ({
		id,
		_type: 'devices' as const,
		position,
	}));

export const buildMockLightsGalleryDashboard = (): DashboardRecord => ({
	id: MOCK_LIGHTS_DASHBOARD_ID,
	name: 'Mock Lights',
	text: 'Mock Lights',
	position: 3,
	route: MOCK_LIGHTS_DASHBOARD_ROUTE,
	protected: true,
	schemaVersion: 1,
	icon: MOCK_LIGHTS_DASHBOARD_TAB.icon,
	backgroundColor: MOCK_LIGHTS_DASHBOARD_TAB.backgroundColor,
	dashWidgets: [
		...COHORT_ORDER.map((cohort, position) => ({
			id: `mock-lights-group-${cohort}`,
			type: 'dashLight' as const,
			title: MOCK_LIGHT_COHORT_LABELS[cohort],
			col: 'left' as const,
			position,
			showWidgetTitle: true,
			cards: [
				{
					id: MOCK_LIGHT_GROUP_IDS[cohort],
					_type: 'groups' as const,
					position: 0,
					bg: COHORT_LIGHT_BG[position % COHORT_LIGHT_BG.length],
				},
			],
		})),
		...COHORT_ORDER.map((cohort, position) => ({
			id: `mock-lights-devices-${cohort}`,
			type: 'dashQuickDev' as const,
			title: MOCK_LIGHT_COHORT_LABELS[cohort],
			col: 'right' as const,
			position,
			showWidgetTitle: true,
			cards: deviceCardsForCohort(cohort),
		})),
	],
});

export const isMockLightsGalleryDashboardId = (id: string | number | undefined | null): boolean =>
	Number(id) === MOCK_LIGHTS_DASHBOARD_ID;

export const MOCK_LIGHT_DEVICE_IDS = MOCK_LIGHT_CATALOG.map((entry) => entry.id);
